angular.module('dnecom')
    .controller('ShippingController', ["$scope", "wizardModal", "Utils", "$http", "$timeout", "notifications", "$location", function($scope, wizardModal, Utils, $http, $timeout, notifications, $location) {
        $scope.loading = false;
        $scope.error = false;
        $scope.tableInstance = {};
        $scope.shippingClasses = [];

        $scope.dtShippingColumnDefs = [
            {
                targets: 1,
                orderable: false,
                width: '150px'
            }
        ];

        $scope.dtInstanceCallback = function(dtInstance)
        {
            $scope.tableInstance = dtInstance;
        };

        $scope.init = function() {
            $scope.getShippingClasses();
        };

        $scope.addShippingClass = function() {
            $scope.editShippingClass();
        };

        $scope.getShippingClasses = function() {
            $scope.loading = true;
            $http.get(Routing.generate('shipping_get')).success(function(data) {
                if (data.hasOwnProperty('shippingClasses')) {
                    $scope.shippingClasses = data.shippingClasses;
                } else {
                    notifications.danger('Request error.');
                }
            }).finally(function() {
                $timeout(function() {
                    $scope.loading = false;
                });
            });
        };

        $scope.getZonesUrl = function(shippingClass) {
            return Routing.generate('shipping_zones', {
                id: shippingClass.id
            });
        };

        $scope.editShippingClass = function(shippingClass, index) {
            if (!shippingClass) {
                shippingClass = {};
            }

            $scope.currentShippingClass = angular.copy(shippingClass);
            var shippingModal = wizardModal.open({
                templateUrl: 'shippingClassModal.html',
                size: null,
                controller: 'ShippingModalController',
                resolve: {
                    shippingClass: function() {
                        return $scope.currentShippingClass;
                    }
                }
            });

            shippingModal.result.then(function(response) {
                $scope.saveShippingClass(response.shippingClass, response.redirect);
            }, function() {
                if (index && !angular.equals($scope.currentShippingClass, $scope.shippingClasses[index])) {
                    $scope.shippingClasses[index] = $scope.currentShippingClass;
                }
            });
        };

        $scope.saveShippingClass = function(shippingClass, redirect) {
            var id = 0;
            if (shippingClass.hasOwnProperty('id')) {
                id = shippingClass.id;
            }

            $http.put(Routing.generate('shipping_update', {
                id: id
            }), shippingClass)
                .then(function(response) {
                    if (response.data.success) {
                        notifications.success('Shipping class saved.');
                        if (id != 0) {
                            $scope.updateShippingClass(response.data.shippingClass);
                        } else {
                            $scope.shippingClasses.push(response.data.shippingClass);
                        }

                        if (redirect) {
                            window.location.href = Routing.generate('shipping_zones', {
                                id: response.data.shippingClass.id
                            });
                        }
                    } else {
                        notifications.danger(response.data.message);
                    }
                }, function(response) {
                    notifications.danger('Request error.');
                });
        };

        $scope.deleteShippingClass = function(shippingClass) {
            $http.delete(Routing.generate('shipping_delete', {
                id: shippingClass.id
            }))
                .then(function(response) {
                    if (response.data.success) {
                        $scope.getShippingClasses();
                        notifications.success('Shipping class has been deleted.');
                    } else {
                        notifications.danger(response.data.message);
                    }
                }, function(response) {
                    notifications.danger('Request error.');
                });
        };

        $scope.updateShippingClass = function(shippingClass) {
            for (var i in $scope.shippingClasses) {
                if ($scope.shippingClasses[i].id == shippingClass.id) {
                    $scope.shippingClasses[i] = shippingClass;
                    return;
                }
            }
        };

        $scope.searchTable = function(search) {
            $scope.tableInstance.DataTable.search(search);
            $scope.tableInstance.DataTable.draw();
        };
    }]);
